import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  ogId: string;
  texto: string;
  onRemove: (ogId: string) => void;
}

const SelectedOGItem: React.FC<Props> = ({ ogId, texto, onRemove }) => {
  return (
    <Box
      data-ogid={ogId}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{ borderRadius: "8px", p: 1 }}
    >
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: "0.7rem",
          color: "rgba(0,0,0,0.6)",
          fontWeight: 500,
          lineHeight: 1.25,
          ml: 1,
          pr: 1,
        }}
      >
        {texto}
      </Typography>

      <IconButton
        size="small"
        onClick={() => onRemove(ogId)}
        sx={{
          color: "rgba(0,0,0,0.55)",
          "&:hover": { color: "#BA4534" },
        }}
      >
        <CloseIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Box>
  );
};

export default SelectedOGItem;
